export default "__VITE_PUBLIC_ASSET__03b327a7__"